import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getBusinessOverview, type GetBusinessOverviewParams } from '../api/businessOverview';

export function useBusinessOverview(params?: GetBusinessOverviewParams) {
  return useQuery({
    queryKey: ['business-overview', JSON.stringify(params ?? {})],
    queryFn: () => getBusinessOverview(params),
    ...listQueryDefaults,
  });
}
